export default class Page {
  uri:string;
  tagNames: Array<string>;
  tags: Array<riot.TagMixin[]>;
  mounted: boolean = false;
  loadHandler: () => void;
  visitHandler: () => void;
  public constructor(tagNames: Array<string>){
    this.uri = window.location.pathname + window.location.search;
    this.tagNames = tagNames;
    this.loadHandler = () => { this.onLoad(); }
    document.addEventListener('turbolinks:load', this.loadHandler );
    this.visitHandler = () => { this.beforeVisit(); }
    document.addEventListener('turbolinks:before-visit', this.visitHandler );
    this.onLoad();
  }
  public onLoad(){
    document.removeEventListener('turbolinks:load', this.loadHandler );
    let currentURI = window.location.pathname + window.location.search;
    if(!this.mounted && this.uri == currentURI){
      this.mountTags();
    }
  }
  public mountTags(){
    this.tags = [];
    for(let i = 0; i < this.tagNames.length; i++){
      let tagName = this.tagNames[i];
      if(!document.querySelector(tagName)){
        console.error('cannot found tag: ' + tagName);
      }
      let tag = riot.mount(tagName);
      this.tags.push(tag);
    }
    this.mounted = true;
  }
  public removeEventListeners(){
    document.removeEventListener('turbolinks:load', this.loadHandler );
    document.removeEventListener('turbolinks:before-visit', this.visitHandler );
  }
  public beforeVisit(){
    this.removeEventListeners();
    this.unmountTags()
  }
  public unmountTags(){
    for(let i = 0; i < this.tags.length; i++){
      for(let j = 0; j < this.tags[i].length; j++){
        this.tags[i][j].unmount(true);
      }
    }
    this.mounted = false;
  }
}
